import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { EMPTY, Observable, of } from "rxjs";
import { share, map, catchError } from "rxjs/operators";
import
{
    IClient,
    INewClient,
    IClientAddress,
    IClientContractDocument,
    INewClientAddress,
    INewClientContractDocument,
    IClientResponse,
    IClientContact,
    IClientOtherContact,
    INewClientBulk
} from "./client.interface";
import { createFormData } from "../util/utilities";
import { IHttpRequestConfig } from "../http/types/http.types";

export class ClientDelegate
{
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }

    public getAllClients(): Observable<IClientResponse>
    {
        return this.http.get(ServiceEndpointConstants.endpoints.CLIENTS.GET).pipe(
            map((response: any) =>
            {
                return {
                    clients: this.normalizeClients(response.data.clients),
                    success: response.data.success
                };
            }),
            share());
    }


    public getAllClientById(clientId: string): Observable<IClientResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                ClientId: clientId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.CLIENTS.GET_CLIENT_BY_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    client: this.normalizeClient(response.data.client),
                    clientId: clientId,
                    success: response.data.success
                };
            }),
            share());
    }
    public createNewClientBulk(newBenchLead: INewClientBulk): Observable<IClientResponse>
    {
        const formdata = createFormData(newBenchLead);

        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.CREATE_BULK, formdata).pipe(
            map((response: any) =>
            {
                return {
                    clients: this.normalizeClients(response.data.clients),
                     message: response.data.message,
                    success: response.data.success
                };
            }),
            share());
    }


    public createNewClient(newClient: INewClient): Observable<IClientResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.CREATE_CLIENT, newClient).pipe(
            map((response: any) =>
            {
                return {
                    clients: this.normalizeClients(response.data.clients),
                    clientId: response.data.clientId,
                    success: response.data.success
                };
            }),
            catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }

    public updateClient(client: IClient): Observable<IClientResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.UPDATE_CLIENT, client).pipe(
            map((response: any) =>
            {
                return {
                    client: this.normalizeClient(response.data.client),
                    clientId: client.clientId,
                    success: response.data.success
                };
            }), catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }

    public createClientContact(newClientAddress: IClientContact): Observable<IClientResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.SAVE_CLIENT_CONTACT, newClientAddress).pipe(
            map((response: any) =>
            {
                return {
                    client: this.normalizeClient(response.data.client),
                    clientId: response.data.clientId,
                    success: response.data.success
                };
            }),
            catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }

    public createClientOtherContact(newClientAddress: IClientOtherContact): Observable<IClientResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.SAVE_CLIENT_OTHER_CONTACT, newClientAddress).pipe(
            map((response: any) =>
            {
                return {
                    client: this.normalizeClient(response.data.client),
                    clientId: response.data.clientId,
                    success: response.data.success
                };
            }),
            catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }

    public createClientAddress(newClientAddress: INewClientAddress): Observable<IClientResponse>
    {
        delete newClientAddress.clientAddressId;
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.SAVE_CLIENT_ADDRESS, newClientAddress).pipe(
            map((response: any) =>
            {
                return {
                    client: this.normalizeClient(response.data.client),
                    clientAddressId: response.data.clientAddressId,
                    clientId: response.data.clientId,

                    success: response.data.success
                };
            }),
            catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }

    public createClientContracts(clientContracts: INewClientContractDocument): Observable<IClientResponse>
    {
        const formdata = createFormData(clientContracts);

        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.CREATE_CLIENT_CONTRACT_DOCUMENT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    clientId: clientContracts.clientId,
                    client: this.normalizeClient(response.data.client),
                    success: response.data.success
                };
            }),
            catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }

    public updateClientAddress(clientAddress: IClientAddress): Observable<IClientResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.UPDATE_CLIENT_ADDRESS, clientAddress).pipe(
            map((response: any) =>
            {
                return {
                    client: this.normalizeClient(response.data.client),
                    clientId: clientAddress.clientId,
                    clientAddressId: clientAddress.clientAddressId,
                    success: response.data.success
                };
            }), catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }

    public updateClientContact(clientAddress: IClientContact): Observable<IClientResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.UPDATE_CLIENT_CONTACT, clientAddress).pipe(
            map((response: any) =>
            {
                return {
                    client: this.normalizeClient(response.data.client),
                    clientId: clientAddress.clientId,
                    success: response.data.success
                };
            }), catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }


    public updateClientOtherContact(clientAddress: IClientOtherContact): Observable<IClientResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTS.UPDATE_CLIENT_OTHER_CONTACT, clientAddress).pipe(
            map((response: any) =>
            {
                return {
                    client: this.normalizeClient(response.data.client),
                    clientId: clientAddress.clientId,
                    success: response.data.success
                };
            }), catchError(error =>
            {
                return of({
                    success: error.data.success,
                    errorString: error.data.errorString
                });

            }),
            share());
    }

    private normalizeClients(clients: any): IClient[]
    {
        return clients.map(client =>
        {
            return this.normalizeClient(client);
        });
    }

    private normalizeClient(client: any): IClient
    {
        client.clientContractDocument = this.normalizeClientDocuments(client.clientContractDocuments);
        client.clientAddress = client.clientAddresses;
        client.clientContact = client.clientContacts;
        client.clientOtherContact = client.clientOtherContacts;

        return client;
    }

    private normalizeClientDocuments(docs: any): IClientContractDocument[]
    {
        return docs.map(doc =>
        {
            return {
                clientContractDocumentId: doc.clientContractDocumentId,
                clientContractDocumentType: doc.configuration,
                clientContractDocumentTypeValue: doc.configuration.configurationValue,
                fileLocationPath: doc.fileLocationPath,
                fileName: doc.fileName
            };
        });
    }
}